// ISDP CUSTOM — i18n "docs" namespace: the All Documentation (/docs) and Curated
// Documentation (/docs-curated) browse pages. These were English-only; German lives
// inline via the `translations` map below (see ./hub.ts for the convention).
import { createTranslationRef } from '@backstage/core-plugin-api/alpha';

export const docsMessages = createTranslationRef({
  id: 'devhub.docs',
  messages: {
    eyebrow: 'Dräger DevHub',
    // All Documentation page.
    all: {
      title: 'All Documentation',
      intro:
        'Product and platform documentation from every Dräger team — powered by TechDocs.',
      searchPlaceholder: 'Search documentation...',
      loading: 'Loading documentation...',
      empty: 'No results match your filters.',
      // {{unit}} is the pluralised entity word below.
      resultCount: '{{filtered}} of {{total}} {{unit}}',
    },
    // Curated Documentation page.
    curated: {
      title: 'Curated Documentation',
      intro:
        'DevHub-approved, quality-checked documentation — the curated shortlist.',
      searchPlaceholder: 'Search curated docs...',
      loading: 'Loading curated documentation...',
      emptyTitle: 'No curated documentation yet',
      emptyDesc:
        'Admins can add documentation to this curated list from the Curation management page.',
      emptySearch: 'No results match your search.',
    },
    unit: {
      one: 'documentation entity',
      other: 'documentation entities',
    },
    // Category is the page's only dropdown filter; the allKinds / allOwners /
    // allLifecycles keys went with the dropdowns they labelled.
    filter: {
      allCategories: 'All Categories',
    },
    clear: 'Clear',
    // Doc card star toggle (favorite/unfavorite the doc's catalog entity).
    card: {
      star: 'Star',
      unstar: 'Unstar',
    },
    error: {
      auth: 'Unable to load documentation — authentication failed.',
      load: 'Failed to load documentation catalog: {{message}}',
    },
  },
  translations: {
    de: () => import('./de/docs'),
  },
});
